import { AuthFunc } from "./AudiostoreAPI";

export interface IPhone {
  phone: string,
  duration: number,
}

export interface IDocumentUpdate {
  recordingId: string,
  notes?: string,
}

export interface IAlignedWord {
  word: string,
  start: number,
  duration: number,
  textStart: number,
  textEnd: number,
  speakerid: number,
  phones: IPhone[],
  confidence: number,
  speakerID: number,
}

export interface IDocument {
  transcriptID: number,
  recordingID: string,
  transcript: string,
  notes: string,
  alignment: IAlignedWord[],
}

export interface ISearchRequest {
  query: string,
  recordedAt?: {
    max: number,
    min: number,
  },
  segmentStart?: {
    max: number,
    min: number,
  },
  recordingSecs?: {
    max: number,
    min: number,
  },
  limit?: number,
  offset?: number,
};

export interface IHit {
  recording_id: string,
  start: number,
  highlight: string,
  score: number,
}

export interface ISearchReply {
  total_hits: number,
  hits: IHit[],
}

export interface IClip {
  id?: string,
  recording_id?: string,
  start?: number,
  duration?: number,
  text?: string,
}

export class SubtitlesAPI {

  private baseURL: string;
  private authFunc: AuthFunc;

  constructor(baseURL: string, authFunc: AuthFunc = async () => null) {
    this.baseURL = baseURL;
    this.authFunc = authFunc;
  }

  public async getTranscript(id: string): Promise<IDocument> {
    return this.fetch(`/transcripts/${id}`);
  }

  public async listTranscripts(): Promise<IDocument[]> {
    return this.fetch('/transcripts');
  }

  public async search(query: ISearchRequest): Promise<ISearchReply> {
    return this.fetch('/search', {
      body: JSON.stringify(query),
      method: 'POST',
    });
  }

  public async saveClip(clip: IClip): Promise<IClip> {
    return this.fetch('/clips', {
      body: JSON.stringify(clip),
      method: 'POST',
    });
  }

  public async listClips(): Promise<IClip[]> {
    return this.fetch('/clips');
  }

  public async autocomplete(query: string): Promise<string[]> {
    const path = `/autocomplete?q=${encodeURIComponent(query)}`
    return this.fetch(path);
  }

  private async fetch(path: string, opts: RequestInit = { }) {
    const url = this.baseURL + path;

    const token = await this.authFunc();
    if (token) {
      opts.headers = {
        ...opts.headers,
        'Authorization': `Bearer ${token}`,
      };
    }

    const resp = await fetch(url, opts);
    if (resp.status !== 200) {
      throw new Error(`failed to fetch ${path}: ${resp.statusText || resp.status}`);
    }
    const data = await resp.json();

    return data;
  }

}

export default SubtitlesAPI;



// WEBPACK FOOTER //
// ./src/api/SubtitlesAPI.ts